import EfScrollAni from '@/efscrollani';
import * as CodeTemp from 'lowcode/plugins/indexS';
import * as CodeTemp2 from 'lowcode/plugins2/indexS';
import Empty from 'lowcode/utils/Empty';
import { Fragment } from 'react';

import 'lowcode/common/css/global.scss';

//import * as Lowcomp from 'lowcomp/plugins/indexS';
import ABTestClient from 'lowcode/common/ABTestClient';
import RedirectUrl from 'lowcode/common/RedirectUrl';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import G from './comps/G';
import H from './comps/H';
import I from './comps/I';
import css from './index.module.scss';

const defaultTemp = {
    //...Lowcomp,
    ...CodeTemp2,
    ...CodeTemp, //常用的务必在后面
};

const AboutUs: React.FC = ({ allTemp = {}, data = {}, className }: any) => {
    const { ABTest, thePage = {}, theTemp = [], theData = {}, theAttr = {}, sqlData = {} } = data;
    const theme = thePage.theme || 'white'; //主题色
    const className2 = className ? ` ${className}` : '';
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`about-us ${css.section}`}>
            <A />
            <B />
            <div className={`about-us-product-container editor-product ${`editor-${theme}`}${className2}`}>
                {theTemp?.map((item: any) => {
                    if (!['0f1e'].includes(item.id)) return null;
                    const id = item.id;
                    const name = item.name;
                    const ContentA = (defaultTemp as any)[name] || allTemp[name] || Empty;
                    // 设置一层隐藏功能
                    if (item.__hide || !id) {
                        return null;
                    }
                    try {
                        return (
                            <Fragment key={id}>
                                <ContentA lowCodeType="preview" id={id} data={theData[id] || {}} attr={theAttr[id] || {}} theme={theme} thePage={thePage} />
                            </Fragment>
                        );
                    } catch (err) {
                        console.log(id, name, err);
                    }
                    return <></>;
                })}
                {thePage.pageCss && <style>{thePage.pageCss}</style>}
                <ABTestClient ABTest={ABTest} />
                <RedirectUrl sqlData={sqlData || {}} />
            </div>
            <G />
            <C />
            <H />
            <I />
        </div>
    );
};

export default AboutUs;
